import AccountsTableItem from './AccountsTableItem'

export default AccountsTableItem
